import styled from 'styled-components';

export const BookmarkContainer = styled.div`
	position: absolute;
	top: 0.5rem;
	right: 0.5rem;
	aspect-ratio: 1/1;
	/* background-color: rgba(var(--ion-color-primary-rgb), 0.2); */
	border-radius: 10px;
	padding: 0.75rem;
	svg {
		path {
			fill: rgba(255, 255, 255, 0.25);
			stroke: var(--ion-color-primary);
			transition: fill 0.3s ease;
		}
	}

	&.bookmarked {
		svg {
			path {
				fill: var(--ion-color-primary);
				stroke: var(--ion-color-primary);
			}
		}
	}
`;
